import { render, staticRenderFns } from "./AnamnesisDetailsDialog.vue?vue&type=template&id=a2418d00&scoped=true"
import script from "./AnamnesisDetailsDialog.vue?vue&type=script&lang=js"
export * from "./AnamnesisDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./AnamnesisDetailsDialog.vue?vue&type=style&index=0&id=a2418d00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2418d00",
  null
  
)

export default component.exports